import axios from 'axios/index';
import { ajaxCallError, beginAjaxCall } from './ajaxStatusActions';
import { baseApi } from '../constants/app';
import * as types from './actionTypes';

export function uploadEntryImagesSuccess(images) {
  return { type: types.UPLOAD_REPAIR_LOG_IMAGE_SUCCESS, images };
}

export function downloadEntryImagesSuccess(images) {
  return { type: types.DOWNLOAD_REPAIR_LOG_IMAGE_SUCCESS, images };
}

export function uploadImage(image, id) {
  return function (dispatch) {
    dispatch(beginAjaxCall());
    let url = baseApi + 'repair-log-entries/' + id + '/images/upload';
    const formData = new FormData();
    const headers = {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    };
    formData.append('file', image);
    return axios
      .post(url, formData, headers)
      .then((response) => {
        dispatch(uploadEntryImagesSuccess(response.data));
      })
      .catch((error) => {
        dispatch(ajaxCallError(error));
        throw error;
      });
  };
}

export function uploadImages(images, id) {
  return function (dispatch) {
    dispatch(beginAjaxCall());
    let url = baseApi + 'repair-log-entries/' + id + '/images/upload/multiple';
    const formData = new FormData();
    const headers = {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    };
    for (let i = 0; i < images.length; i++) {
      formData.append('files', images[i]);
    }
    return axios
      .post(url, formData, headers)
      .then((response) => {
        dispatch(uploadEntryImagesSuccess(response.data));
      })
      .catch((error) => {
        dispatch(ajaxCallError(error));
        throw error;
      });
  };
}

export function downloadImages(id) {
  return function (dispatch) {
    dispatch(beginAjaxCall());
    let url = baseApi + 'repair-log-entries/' + id + '/images/download';
    return axios
      .get(url)
      .then((response) => {
        dispatch(downloadEntryImagesSuccess(response.data));
      })
      .catch((error) => {
        dispatch(ajaxCallError(error));
        throw error;
      });
  };
}



// WEBPACK FOOTER //
// ./src/actions/imageActions.js